module.exports = __webpack_public_path__ + "f2a1f6a4cc4b07b6d2181ef8d1da679a.png";